import React from 'react'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import CONS from "../constants"
import Alert from "../functions/alert"
import Valid from "../functions/validation"
import MainLayout from "../components/main-layout"
import ServiceChargeUI from "./service-charge-ui"

class ServiceCharge extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            attr: {
                access_token: "",
                loading: true
            },
            data: {
                service_th: "",
                service_en: "",
                service_2_th: "",
                service_2_en: "",
                service_3_th: "",
                service_3_en: "",
                is_servicecharge: "1"
            },
        }
    }

    handleChange = (e) => {
        this.setState({ data: { ...this.state.data, is_servicecharge: (e.target.checked ? "1" : "0") } }, () => {
            var params = this.state.data
            axios.post(CONS.API_INFORMATION + "/update/servicecharge", params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': CONS.AUTH_PREFIX + this.state.attr.access_token
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    localStorage.removeItem('login_token')
                    this.props.history.push(CONS.URL_LINK + '/login?auth=false')
                } else {
                    console.log(error)
                }
            })
        })
    }

    handleChangeEditor = (e) => {
        this.setState({ data: { ...this.state.data, [e.name]: e.value } })
    }

    handleSave = () => {
        var valid = Valid.form("submit-form")
        if (valid) {
            var params = this.state.data
            axios.post(CONS.API_INFORMATION + "/update/service", params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': CONS.AUTH_PREFIX + this.state.attr.access_token
                }
            }
            ).then((response) => {
                if (response.data.status === "success") {
                    Alert.showMsg('บันทึกสำเร็จ')
                } else {
                    localStorage.removeItem('login_token')
                    this.props.history.push(CONS.URL_LINK + '/login?auth=false')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    localStorage.removeItem('login_token')
                    this.props.history.push(CONS.URL_LINK + '/login?auth=false')
                } else {
                    console.log(error)
                }
            })
        }
    }

    loadData = () => {
        axios.post(CONS.API_INFORMATION + "/get", {
            type: "service"
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': CONS.AUTH_PREFIX + this.state.attr.access_token
            }
        }
        ).then((response) => {
            if (response.data.status === "success") {
                this.setState({ data: response.data.information, attr: { ...this.state.attr, loading: false } })
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                localStorage.removeItem('login_token')
                this.props.history.push(CONS.URL_LINK + '/login?auth=false')
            } else {
                console.log(error)
            }
        })
    }

    checkToken = (access_token) => {
        this.setState({ attr: { ...this.state.attr, access_token: access_token } }, this.loadData)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <MainLayout active="servicecharge" authorized="servicecharge" onCheckToken={this.checkToken}>
                <ServiceChargeUI {...this} />
            </MainLayout>
        )
    }
}

export default withRouter(ServiceCharge)

